import styled from "styled-components"

type StyledButtonProps = {
    variant: 'primary' | 'secondary' | 'gradient' | 'player',
}
const StyledButton = styled.button<StyledButtonProps>`
   
   @media only screen and ( max-width: 426px)
    {
        width: ${props => props.variant === 'player' ? '313px' : '100%'};
        /* height: 40px; */
        overflow-wrap: break-word;
        padding: ${props => props.variant === 'player' ? '5px 0px 6px 0px' : '11px 15px'};
    }
    z-index: 1; 
    cursor: pointer;
    
    /* Player variant styles */
    ${props => props.variant === 'player' && `
        display: flex;
        width: 313px;
        height: 40px;
        padding: 5px 0px 6px 0px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        border: 4px solid #E6D2A6;
        background: linear-gradient(180deg, #AB8C57 0%, #FFF6ED 100%);
        box-shadow: 0px 0px 20px 0px #E6D2A6;
        color: #000;
        font-weight: bold;
        font-size: 22px;
        font-family: var(--font-rowdies);
        text-align: center;
        text-transform: uppercase;
        
        &:disabled {
            opacity: 0.3;
            cursor: default;
            box-shadow: 0px 0px 10px 0px #E6D2A6;
        }
        
        &:hover:not(:disabled) {
            box-shadow: 0px 0px 25px 0px #E6D2A6;
        }
    `}
    
    /* Default styles for other variants */
    ${props => props.variant !== 'player' && `
        min-width: 313px;
        color: #fff;
        font-weight: bold;
        font-size: 22px;
        font-family: var(--font-rowdies);
        text-align: center;
        text-transform: uppercase;
        padding: 11px 32px;
        background: ${props.variant === 'gradient' ? 'linear-gradient(180deg, #451d58 0%, #3f035b 100%)' : 
        props.variant === 'primary' ? props.theme.colors.green.main: '#000000'};
        border-radius: 4px;
        border: none;
        
        &:disabled {
            opacity: 0.3;
            cursor: default;
        }
    `}
    
    &.descktopLabelButton {
        /* height: 70px; */
        font-size: 50px;
        padding: 6px 38px;
        overflow-wrap: break-word;
        font-family: var(--font-gotham);
    }
`;

type Props = {
    children?: any,
    onClick?: () => void,
    variant?: 'primary' | 'secondary' | 'gradient' | 'player',
    style?: React.CSSProperties | undefined,
    className?: string | undefined,
    disabled?: boolean,
    type?: 'button' | 'submit' | 'reset'
}

export const Button = ({ children, onClick, variant = 'primary', style, className, disabled, type = 'button' }: Props) => {

    return (
        <StyledButton disabled = { disabled } style = { style } className = { className } onClick = { onClick } variant = { variant } type = { type }>{ children }</StyledButton>
    )
}
